import { render, staticRenderFns } from "./RoundedButtonComponent.vue?vue&type=template&id=ff00908e&"
import script from "./RoundedButtonComponent.vue?vue&type=script&lang=js&"
export * from "./RoundedButtonComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports